var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsIconInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h31.999v32H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    fillRule: "evenodd",
    d: "M22.667 32H9.333C4.201 32 0 27.8 0 22.667V9.334C0 4.199 4.201 0 9.333 0h13.334c5.134 0 9.332 4.199 9.332 9.334v13.333c0 5.133-4.198 9.333-9.332 9.333zm6.667-22.666c0-1.768-.692-3.451-1.959-4.709-1.266-1.258-2.942-1.958-4.708-1.958H9.333c-1.766 0-3.449.691-4.708 1.958-1.258 1.267-1.957 2.941-1.957 4.709v13.333c0 1.766.69 3.45 1.957 4.707 1.267 1.26 2.942 1.96 4.708 1.96h13.334c1.766 0 3.449-.692 4.708-1.96 1.258-1.265 1.959-2.941 1.959-4.707V9.334zm-4.668 0c-1.107 0-1.999-.893-1.999-2.001 0-1.108.892-2 1.999-2 1.101 0 2 .892 2 2s-.899 2.001-2 2.001zm-8.667 14.665c-4.415 0-7.998-3.583-7.998-7.999 0-4.417 3.583-8 7.998-8C20.417 8 24 11.583 24 16c0 4.416-3.583 7.999-8.001 7.999zm0-13.332c-2.94 0-5.333 2.391-5.333 5.333 0 2.941 2.393 5.334 5.333 5.334 2.942 0 5.333-2.393 5.333-5.334 0-2.942-2.391-5.333-5.333-5.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsIconInsta);
export default __webpack_public_path__ + "static/media/sns-icon-insta.abe4e9b60adcc17473b0f92035f2acff.svg";
export { ForwardRef as ReactComponent };